import { Box } from '@origin-digital/layout';
import { Colors, LinkText } from '@origin-digital/style-guide';
import * as React from 'react';
import { AuthCard } from '../../../../components/Card';
import { Heading } from '../../../../components/Heading';
import { InfoText } from '../../../../components/InfoText';
import { Separator } from '../../../../components/Separator';
import { Page } from '../../../../components/Page';

interface AccountFoundViewProps {
  email: string;
  forgotPasswordHref: string;
  children?: React.ReactNode;
}

const AccountFoundView: React.FC<AccountFoundViewProps> = ({
  email,
  forgotPasswordHref,
  children,
}) => {
  return (
    <Page>
      <AuthCard>
        <div>
          <Heading text="Hooray we found your account" />
          <InfoText text={`Enter the password for **${email}** to log in.`} />
          {children}
          <Box marginTop={8} marginBottom={8}>
            <LinkText
              componentType="link"
              label="forgot-my-password"
              data-id="forgot-email"
              color="dark"
              text="Forgot my password"
              href={forgotPasswordHref}
            />
          </Box>
          <Separator color={Colors.GREY8} />
          <Box display="flex" justifyContent="center" marginTop={8}>
            <LinkText
              componentType="link"
              label="change-email-link"
              color="red"
              data-id="change-email-link"
              href="https://www.originenergy.com.au/feedback/?formCode=app_login_support&title=Feedback"
              text="Need to change your email? Contact us"
            />
          </Box>
        </div>
      </AuthCard>
    </Page>
  );
};

export { AccountFoundView };
